import React, { Component, createRef } from 'react'
import _ from 'lodash'
import classnames from 'classnames'

class JarvisWidget extends Component {
  static defaultProps = {
    colorbutton: true,
    editbutton: true,
    togglebutton: true,
    deletebutton: true,
    fullscreenbutton: true,
    custombutton: false,
    collapsed: false,
    sortable: true,
    hidden: false,
    color: false,
    load: false,
    refresh: false
  }

  constructor(props) {
    super(props)
    this.widgetId = _.uniqueId('jarviswidget-')
    this.widgetRef = createRef()
  }

  componentDidMount() {
    $(this.widgetRef.current)
      .find('.widget-body')
      .prepend(
        '<div class="jarviswidget-editbox"><input class="form-control" type="text"></div>'
      )
  }

  render() {
    const colorClass = this.props.color
      ? 'jarviswidget-color-' + this.props.color
      : ''
    const classes = classnames('jarviswidget', colorClass, {
      'jarviswidget-sortable': this.props.sortable === true
    })

    const widgetProps = {}

    ;[
      'colorbutton',
      'editbutton',
      'togglebutton',
      'deletebutton',
      'fullscreenbutton',
      'custombutton',
      'sortable'
    ].forEach(option => {
      if (!this.props[option]) {
        widgetProps['data-widget-' + option] = false
      }
    })
    ;['hidden', 'collapsed'].forEach(option => {
      if (this.props[option]) {
        widgetProps['data-widget-' + option] = true
      }
    })
    ;['refresh', 'load'].forEach(option => {
      if (this.props[option]) {
        widgetProps['data-widget-' + option] = this.props[option]
      }
    })

    return (
      <div
        className={classes}
        id={this.widgetId}
        ref={this.widgetRef}
        {...widgetProps}
      >
        {this.props.children}
      </div>
    )
  }
}

const JarvisWidgetBody = ({ children, ...props }) => (
  <div {...props}>
    <div className="widget-body">
      {children}
    </div>
  </div>
)

JarvisWidget.Body = JarvisWidgetBody

export default JarvisWidget
